import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { history } from 'store/RouteState';
import { MoreIcon, CopyIcon } from 'components/Svg';
import * as Icons from 'components/Svg';
import Spinner from './Spinner';



export const Button = React.forwardRef((p, ref) => {
  let { className, loading, disabled, submit, size, color, type, icon, position = 'left', href, target, children, onClick, ...props } = p;

  let onElmClick = e => {
    e.preventDefault();
    if(href) {
      if(href.indexOf("http") !== -1) {
        if(!target) {
          window.location = href;
        } else {
          window.open(href);
        }
      } else {
        history.push(href);
      }
    } 
    onClick?.(e);
  }

  type = type === 'outline' 
    ? 'o' 
    : type === 'text' 
      ? 'tx' 
      : type;
  
  return (
    <button
      type={submit ? "submit" : "button"}
      {...props}
      ref={ref}
      disabled={disabled || loading}
      className={cx("btn", size, color, type, className, { loading })}
      onClick={!submit ? onElmClick : null }>
      <span className="btn-content">
        { loading ? <Spinner size="s" color="button" /> : null }
        { children }
      </span>
    </button>
  );
});





// ====================
// BUTTON LIST
// ====================
export const ButtonList = ({ className, direction = 'row', size, align, ...props }) => (
  <div className={cx("btn-list", className, direction, align, size)} {...props}></div>
)
export const ButtonListCol = ({ direction, ...props }) => (<ButtonList direction={"column"} {...props} />)
export const ButtonListUniform = ({ direction, size, ...props }) => (<ButtonList direction={"column"} align="stretch" {...props} />)
export const ButtonListCenter = ({ direction, align, ...props }) => (<ButtonList direction={"row"} align="center" {...props} />)

export const IconButtonList = ({ className, direction = 'row', align, ...props }) => (
  <div className={cx("btn-list", "icons", "light", className, direction, align)} {...props}></div>
)


// ====================
// OUTLINE
// ====================
export const OutlineButton = props => <Button {...props} type="outline"></Button>;

// ====================
// SUB / SECONDARY
// ====================
export const SubButton = props => <Button {...props} type="sub"></Button>;
export const ActionButton = props => <Button {...props} type="action"></Button>;

// ====================
// TEXT
// ====================
export const TextButton = React.forwardRef((props, ref) => <Button {...props} ref={ref} type="text"></Button>);


export const CircleButton = React.forwardRef((props, ref) => <Button {...props} ref={ref} type="c"></Button>);


// ====================
// SIZE
// ====================
export const SmallButton = props => <Button {...props } size="s"/>;
export const XSmallButton = props => <Button {...props} size="xs" />;

// ====================
// ICONS
// ====================
export const OldIconButton = React.forwardRef((p, ref) => {
  let {icon, className, children, ...props} = p;
  return <Button {...props} ref={ref} className={cx("i", className)}><i className={`icon-${icon}`} /></Button>;
})

export const IconButton = React.forwardRef(
  ({ className, size, color = 'transparent', ...props }, ref) => 
    <Button {...props} ref={ref} className={cx("i", className, size)} color={color} />);

const createIconButton = (icon, name) => React.forwardRef(
  ({className, size = 'm', color, ...props}, ref) => (
    <IconButton 
      {...props} 
      ref={ref} 
      className={cx(name, className)}
      size={size}
      color={color}>
      { React.cloneElement(icon, { size, color })  }
    </IconButton>)
);


// ====================
// SPECIFIC
// ====================
export const TwitchButton = ({className, ...p}) => <Button {...p} className={cx("twitch", className)}>Twitch</Button>;
export const TwitchLoginButton = ({className, ...p}) => <Button {...p} className={cx("twitch", "login", className)} size="l"><Icons.TwitchIcon /> Twitch</Button>;
export const EditButton = ({children = "Edit",...props}) => <Button {...props} className="edit"><Icons.EditIcon />{children}</Button>;
export const ModalCloseButton = p => <CircleButton {...p} className="modal-close"><Icons.XMarkIcon /></CircleButton>;
export const SaveButton = ({ children = "Save", ...props }) => <Button {...props} className="save"><Icons.SaveIcon /> {children}</Button>;
export const CancelButton = ({ children = "Cancel", ...props }) => <SubButton {...props} className="cancel">{children}</SubButton>;
export const NewButton = ({ children = "New", ...props }) => <Button {...props} className="new">{children}</Button>;
export const AddButton = ({ children = "Add", ...props }) => <Button {...props} className="add"><Icons.PlusIcon size={props.size} /> {children}</Button>;
export const SettingsButton = ({ children = "Settings", ...props }) => <Button {...props} className="settings"><Icons.SettingsIcon size={props.size} /> {children}</Button>;
export const DeleteButton = ({ children = "Delete", ...props }) => <Button {...props} className="delete"><Icons.DeleteIcon size={props.size} /> {children}</Button>;

export const CircleAddButton = React.forwardRef((props, ref) => <CircleButton ref={ref} className="add" {...props}><Icons.PlusIcon /></CircleButton>)

export const AddIconButton = createIconButton(<Icons.PlusIcon />, 'add');
export const BackIconButton = createIconButton(<Icons.BackIcon />, 'back');
export const PlayIconButton = createIconButton(<Icons.PlayIcon />, 'play');
export const StopIconButton = createIconButton(<Icons.StopIcon />, 'stop');
export const PauseIconButton = createIconButton(<Icons.PauseIcon />, 'pause');
export const MoreIconButton = createIconButton(<Icons.MoreIcon />, 'more');
export const MoveIconButton = createIconButton(<Icons.MoveIcon />, 'move');
export const PlusIconButton = createIconButton(<Icons.PlusIcon />, 'plus');
export const RefreshIconButton = createIconButton(<Icons.RefreshIcon />, 'refresh');
export const EditIconButton = createIconButton(<Icons.EditIcon />, 'edit-icon');
export const DeleteIconButton = createIconButton(<Icons.DeleteIcon />, 'delete');
export const XIconButton = createIconButton(<Icons.XMarkIcon />, 'x-mark');
export const CopyIconButton = createIconButton(<Icons.CopyIcon />, 'copy');
export const DownloadIconButton = createIconButton(<Icons.DownloadIcon />, 'download');
export const GraphIconButton = createIconButton(<Icons.GraphIcon />, 'graph');
export const LinkIconButton = createIconButton(<Icons.LinkIcon />, 'link');
export const SettingsIconButton = createIconButton(<Icons.SettingsIcon />, 'settings');
export const SlideshowIconButton = createIconButton(<Icons.SlideshowIcon />, 'slideshow');


export { Button as default };

